import { PageHeader, Tabs } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { PlansProvider } from '../../components/FinanceEngine/context/PlansContext';
import { Plans } from '../../components/FinanceEngine/Plans';
import { BookingVariables } from '../../components/FinanceEngine/components/BookingVariables';
import { VariableProvider } from '../../components/FinanceEngine/context/VariableContext';

const { TabPane } = Tabs;

const FinanceEngineScreen = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const tab = searchParams.get('tab') || 'plans';

    const handleTabChange = (key: string) => {
        searchParams.set('tab', key);
        setSearchParams(searchParams);
    };

    return (
        <PageHeader
            title="Finance Engine"
            style={{ padding: '32px 24px 24px 0' }}
            footer={(
                <Tabs defaultActiveKey={tab} onTabClick={handleTabChange}>
                    <TabPane tab="Plans" key="plans">
                        <PlansProvider>
                            <Plans />
                        </PlansProvider>
                    </TabPane>
                    <TabPane tab="Global Variables" key="global-variables">
                        <VariableProvider>
                            <BookingVariables filters pagination />
                        </VariableProvider>
                    </TabPane>
                </Tabs>
            )}
        />
    );
};

export { FinanceEngineScreen };
